export const cardSize = 97;
export const cardSizeMobileM = 106;
export const cardMargin = 8;
export const sidePadding = 44;
export const sidePaddingMobile = 4;
